import styled, { keyframes } from "styled-components";

// Shimmer keyframes for placeholder skeleton loading
const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div`
  border-radius: 4px;
  background: var(--PEARL, #ecf1f4);
  background-image: linear-gradient(
    90deg,
    var(--PEARL, #ecf1f4) 0%,
    #f2f5f7 20%,
    var(--PEARL, #ecf1f4) 40%,
    var(--PEARL, #ecf1f4) 100%
  );
  background-size: 800px 104px;
  animation: ${shimmer} 1.2s infinite linear;
`;

// Navbar Skeleton Wrapper
export const NavbarSkeletonContainer = styled.div`
  margin: 0 120px;
  display: flex;
  gap: 16px;
  padding: 10px 0;
  overflow: hidden;
`;

export const NavbarTabSkeleton = styled(SkeletonBase)`
  width: 90px;
  height: 32px;
  flex-shrink: 0;
`;

// Card Skeleton Wrapper
export const CardGridSkeleton = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const CardSkeletonContainer = styled.div`
  border-radius: 4px;
  border: 1px solid #ecf1f4;
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 410px; /* Approximated height of card details */
`;

export const StatusSkeleton = styled(SkeletonBase)`
  width: 70px;
  height: 20px;
  margin-bottom: 8px;
`;

export const ImageSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 180px;
  margin-bottom: 24px;
`;

export const SkuSkeleton = styled(SkeletonBase)`
  width: 100px;
  height: 14px;
  margin-bottom: 12px;
`;

export const TitleSkeleton = styled(SkeletonBase)`
  width: 90%;
  height: 18px;
  margin-bottom: 8px;
`;

export const PriceSkeleton = styled(SkeletonBase)`
  width: 60px;
  height: 20px;
  margin-bottom: 20px;
`;

export const FooterSkeletonRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: auto;
`;

export const QuantitySkeleton = styled(SkeletonBase)`
  width: 80px;
  height: 32px;
`;

export const AddButtonSkeleton = styled(SkeletonBase)`
  flex-grow: 1;
  height: 32px;
`;
